import React from "react";
import { useTranslation } from "react-i18next";
import { UncontrolledDropdown, DropdownToggle, DropdownMenu, DropdownItem } from "reactstrap";
import { isLoanFundType } from "utils/interestTransactions";

/**
 * Alasvetovalikko Toiminnot-painikkeen alla.
 * Näyttää toimintovalinnat rivikohtaisesti (Osinko, Split, Kurssi jne.)
 */
const ToiminnotActionsDropdown = ({ row, onSelectAction, account, isRealEstate = false }) => {
  const { t } = useTranslation();

  const value_id = row?.id;
  const related_model_type = value_id ? value_id.split(",")[0] : null;
  const fund_type = value_id ? value_id.split(",")[1] : null;
  const related_model_id = value_id ? value_id.split(",")[2] : null;

  const handleClick = (action) => (e) => {
    e.stopPropagation();
    onSelectAction(action, row);
  };

  // Lainatyyppisille kohteille osingon tilalla on korkokirjaus (33/34)
  const showInterest = related_model_type == 30 && isLoanFundType(fund_type);
  const showDividend = related_model_type < 40 && !showInterest;
  const showRate = related_model_type == 30;
  const showAccounting = related_model_type == 30 && account?.show_relation_to_security;
  const showSplit = related_model_type == 30;
  const showRentContract = isRealEstate && related_model_type == 30;
  const showDocument = isRealEstate && related_model_type == 30;

  return (
    <UncontrolledDropdown>
      <DropdownToggle className="btn-sm font-weight-normal text-dark" color="default" size="sm" caret>
        <i className="fas fa-plus mr-1"></i>
        {t("PrivateInvestmentFundsList_table_add_event", "Toiminnot")}
      </DropdownToggle>
      <DropdownMenu>
        {showInterest && (
          <DropdownItem onClick={handleClick("interest")}>
            <i className="fas fa-percent mr-2"></i>
            {t("new_record_interest", "Kirjaa korkotuotto")}
          </DropdownItem>
        )}
        {showDividend && (
          <DropdownItem onClick={handleClick("dividend")}>
            <i className="fas fa-coins mr-2"></i>
            {t(isRealEstate ? "real_estate_new_record_dividend" : "new_record_dividend", isRealEstate ? "Kirjaa uusi kulu/tuotto" : "Kirjaa uusi osinko")}
          </DropdownItem>
        )}
        {showRate && (
          <DropdownItem onClick={handleClick("rate")}>
            <i className="fas fa-chart-line mr-2"></i>
            {t(isRealEstate ? "real_estate_new_record_rate" : "new_record_rate", isRealEstate ? "Kirjaa uusi markkina-arvo" : "Kirjaa uusi kurssi")}
          </DropdownItem>
        )}
        {showAccounting && (
          <DropdownItem onClick={handleClick("accounting")}>
            <i className="fas fa-calculator mr-2"></i>
            {t("new_record_accounting", "Päivitä kirjanpitoarvo")}
          </DropdownItem>
        )}
        {showSplit && (
          <DropdownItem onClick={handleClick("split")}>
            <i className="fas fa-code-branch mr-2"></i>
            {t("new_record_split", "Kirjaa uusi split")}
          </DropdownItem>
        )}
        {showRentContract && (
          <DropdownItem onClick={handleClick("rent_contract")}>
            <i className="fas fa-file-contract mr-2"></i>
            {t("real_estate_new_record_rent_contract", "Lisää vuokrasopimus")}
          </DropdownItem>
        )}
        {showDocument && (
          <DropdownItem onClick={handleClick("document")}>
            <i className="fas fa-file-alt mr-2"></i>
            {t("real_estate_new_record_rent_contract", "Lisää tosite")}
          </DropdownItem>
        )}
        <DropdownItem onClick={handleClick(related_model_type == 30 ? "fund" : "securityAccount")}>
          <i className="fas fa-edit mr-2"></i>
          {t("new_record_edit", "Muokkaa")}
        </DropdownItem>
      </DropdownMenu>
    </UncontrolledDropdown>
  );
};

export default ToiminnotActionsDropdown;
